import { useQuery } from 'react-query';

import { getDevicesInWarehouse } from 'api/traps/DevicesWareHouse/getDevicesInWarehouse';

export const useGetDevicesInWarehouse = (isAll: boolean) => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    'DevicesInWarehouse',
    () => getDevicesInWarehouse(isAll),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isRefetching };
};

export default useGetDevicesInWarehouse;
